document.addEventListener( 'wpcf7mailsent', function( event ) {
    if (event.detail.contactFormId == 1206 ) {
        const file = $('input[name="file"]').val();
        fetch(file)
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = 'brochure.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }
});
